export default __webpack_public_path__ + "static/media/signal-blocked.eee266e8.svg";